import React from 'react';
import PageTemplate from '@/components/ui/PageTemplate';
import Googlemap, { OFFICES } from '@/components/company/Googlemap';
import SNS from '@/components/company/SNS';
import ContactForm from '@/components/company/ContactForm';
import useObserver from '@/hooks/page/useObserver';

const Contact = () => {
  useObserver(
    'content-Contact',
    'content-Contact-tablet',
    'content-Contact-desktop'
  );

  return (
    <PageTemplate id='Contact'>
      {/* Mobile Layout */}
      <div
        id='content-Contact'
        className='md:hidden w-full pt-20 pb-24 flex flex-col gap-10 bg-cover bg-center bg-no-repeat'
        style={{ backgroundImage: "url('/redesign/BG_Resources.png')" }}
      >
        <div className='flex flex-col w-full max-w-[360px] mx-auto gap-10 px-4'>
          <h2 className='text-[20px] font-bold text-[#FFFFFF] m-0'>Contact</h2>
          <ContactForm />
        </div>

        {/* Location Cards */}
        <div className='flex flex-col gap-2 w-full max-w-[360px] mx-auto px-4'>
          {OFFICES.map(office => (
            <div
              key={office.title}
              onWheel={e => e.stopPropagation()}
              onTouchEnd={e => e.stopPropagation()}
              className='w-full'
            >
              <Googlemap
                location={office.location}
                width='100%'
                height='200px'
                zoom={15}
                title={office.title}
                address={office.address}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tablet Layout */}
      <div
        id='content-Contact-tablet'
        className='hidden md:flex xl:hidden w-full min-h-full bg-cover bg-center bg-no-repeat flex-col py-36 gap-24 relative'
        // style={{ backgroundImage: "url('/redesign/BG_Resources.png')" }}
      >
        <div className='flex flex-col justify-start items-start w-full md:max-w-[688px] mx-auto'>
          <h1 className='text-[30px] font-semibold text-[#FFFFFF]'>Contact</h1>
        </div>
        <div className='w-full md:max-w-[688px] mx-auto flex flex-col gap-24'>
          <div className='relative z-20 flex flex-row gap-14'>
            <div className='w-[100%] flex flex-col gap-4'>
              <div className='w-full flex justify-start'>
                <ContactForm />
              </div>
            </div>
          </div>
          <div className='w-full flex flex-col gap-8 justify-center items-center'>
            <div className='grid grid-cols-2 gap-8 md:w-full'>
              {OFFICES.map(office => (
                <div
                  key={office.title}
                  className='flex flex-col gap-4 items-center w-full h-full'
                >
                  <div
                    onWheel={e => e.stopPropagation()}
                    onTouchEnd={e => e.stopPropagation()}
                    className='w-full h-full'
                  >
                    <Googlemap
                      location={office.location}
                      width='100%'
                      height='280px'
                      zoom={15}
                      title={office.title}
                      address={office.address}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div
        id='content-Contact-desktop'
        className='hidden xl:flex w-full min-h-full bg-cover bg-center bg-no-repeat flex-col py-36 gap-24 relative'
        // style={{ backgroundImage: "url('/redesign/BG_Resources.png')" }}
      >
        <div className='flex flex-col justify-start items-start w-full xl:max-w-[1060px] md:max-w-[688px] mx-auto'>
          <h1 className='text-2xl font-semibold text-[#FFFFFF]'>Contact</h1>
        </div>
        <div className='w-full xl:max-w-[1060px] md:max-w-[688px] mx-auto flex flex-col gap-14'>
          <div className='relative z-20 flex flex-col gap-14'>
            <div className='w-full flex flex-col gap-4'>
              <div className='w-full flex justify-start'>
                <ContactForm />
              </div>
            </div>
          </div>
          <div className='w-full flex flex-col gap-8'>
            <div className='grid grid-cols-2 gap-8'>
              {OFFICES.map(office => (
                <div
                  key={office.title}
                  className='flex flex-col gap-4 items-center w-full h-full'
                >
                  <div
                    onWheel={e => e.stopPropagation()}
                    onTouchEnd={e => e.stopPropagation()}
                    className='w-full h-full'
                  >
                    <Googlemap
                      location={office.location}
                      width='100%'
                      height='250px'
                      zoom={15}
                      title={office.title}
                      address={office.address}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default React.memo(Contact);
